import type LegalEntity from 'modules/core/store/models/LegalEntity'

import SpainOccupationCode from 'modules/contracts/store/models/SpainOccupationCode'

import { PayrollLegalEntityResource } from '../payrollLegalEntityResource'

class OccupationCodes extends PayrollLegalEntityResource<SpainOccupationCode> {
  model() {
    return SpainOccupationCode
  }

  fetchByLegalEntityIds(legalEntityIds: number[]) {
    this.fetch({ data: { legal_entity_ids: legalEntityIds } })
  }

  /**
   * @override
   * The PayrollLegalEntityResource class has a computed property called actives
   * that filters the resources by the isActive property. This property is not
   * present in the OccupationCodes model, so we override the actives property
   */
  get actives() {
    return this.models
  }

  /**
   * @override
   * Fetch data by legal entity when the resource support multiple legal entitis.
   * @param legalEntity The occupation codes legal entities.
   */
  fetchByLegalEntity(legalEntity: LegalEntity) {
    const legalEntityId = legalEntity.attributes.id
    this.fetchByLegalEntityIds([legalEntityId])
  }
}

export { OccupationCodes }
